import { array, arrayOf, bool, shape, string } from "prop-types";
import { baseDatabaseModelType } from "./baseDatabaseModel";
import { projectMilestoneRole } from "./projectMilestoneRole";

/** @deprecated use TypeScript interface or type instead */
export const projectMilestoneType = shape({
  ...baseDatabaseModelType,
  abbreviation: string,
  id: string,
  name: string,
  displayName: string,
  milestoneTemplateId: string,
  isFromGlobalTemplate: bool,
  status: string,
  notificationsRequired: bool,
  documentsRequired: bool,
  childMilestones: array,
  notificationGroups: array,
  canBeAdded: bool,
  canBeDeletes: bool,
  approvalRequired: bool,
  canBeSkipped: bool,
  dateDeleted: string,
  tasks: array,
  comments: array,
  areProjectSkusRequired: bool,
  targetDate: string,
  actualDate: string,
  shouldCompleteProject: bool,
  approvers: arrayOf(projectMilestoneRole),
});
